/*
Client side measurements

this.metrics = new Metrics('Module Name',{average:true});
this.metrics.add('start retrieveData');
this.metrics.add('end retrieveData');
this.metrics.add('start render objects');
this.metrics.add('end render objects');
this.metrics.draw(); // displays in the console

*/

Metrics = function (name, oArgs) {

	this.oArgs = oArgs || {};

	this.name = name || "Timer";

	this.oArgs.average = this.oArgs.average === true ? 5 : (this.oArgs.average || 0);

	var metrics = location.href.match(/[?|&]metrics=(.*?)(&|#|$)/);

	this.isEnabled = this.oArgs.enabled || (metrics && metrics[1].match("(^|\|)" + this.name + "($|\|)"));

	this.start();
}

Metrics.prototype.start = function () {
	this.startDate = new Date();
	this.laps = {};
}

Metrics.prototype.reset = Metrics.prototype.start;


Metrics.prototype.lap = function (name) {
	this.laps[name] = new Date();
}

Metrics.prototype.add = Metrics.prototype.lap;

Metrics.prototype.commatize = function (n, length, pad) {

	n += ""; var ns = "", rem = ""; var dp = n.indexOf('.'); var sp = (dp >= 0) ? dp : n.length; ns = n.substring(sp, n.length); n = n.substring(0, sp); rem = n; for (var i = n.length - 3; i > 0; i -= 3) { ns = ',' + n.substring(i, i + 3) + ns; rem = n.substring(0, i); };
	var s = rem + ns;

	if (length) {
		return this.padL(s, length, pad);
	}

	return s;
}

Metrics.prototype.padL = function (s, length, pad) {
	while (s.length < length)
		s = (pad || " ") + s;
	return s;
}

Metrics.prototype.padR = function (s, length, pad) {
	while (s.length < length)
		s = s + (pad || " ");
	return s;
}


Metrics.prototype.draw = function () {

	if (!this.isEnabled) { return; }

	var startMS = this.startDate.getTime();
	var endMS = (new Date()).getTime();

	var label = "Timer for: " + this.name;

	if (console.group) {
		console.group(label);
	}
	else {
		console.log(label);
	}

	var lapTimeEnd, lastLapTimeEnd = startMS;
	for (var i in this.laps) {
		lapTimeEnd = this.laps[i].getTime();
		console.log(this.padR(i + ':', 20) + this.commatize(lapTimeEnd - lastLapTimeEnd, 10) + this.commatize(lapTimeEnd - startMS, 10));
		lastLapTimeEnd = lapTimeEnd;
	}

	var totalTime = endMS - startMS;

	console.log(this.padR('Total:', 20) + this.padR('', 10) + this.commatize(totalTime, 10));

	this.logAverage(totalTime);

	if (console.groupEnd) {
		console.groupEnd(label);
	}
}

Metrics.prototype.getTime = function () {

	var startMS = this.startDate.getTime();
	var endMS = (new Date()).getTime();

	return endMS - startMS;

}

Metrics.prototype.logAverage = function (totalTime) {

	if (!this.oArgs.average) { return; }

	var times = $.cookie('metrics_' + this.name) || '';

	times = times ? times.split(',') : [];

	times.push(totalTime);
	times.reverse();
	times = times.slice(0, this.oArgs.average);

	$.cookie('metrics_' + this.name, times.reverse().join(','));

	var total = 0;

	for (var i = 0; i < times.length; i++) {
		total += Number(times[i]);
	}

	var average = Math.floor((total / times.length) * 100) / 100;

	console.log(this.padR('Average of last ' + times.length + ':', 20) + this.padR(average, 10) + this.commatize('', 10) + "Metrics.clearAverage('" + this.name + "')");

	if ($.query && $.query.get('clearmetrics').match("(^|\\|)" + this.name + "($|\\|)")) {
		this.clearAverage();
	}



}

Metrics.prototype.clearAverage = function (totalTime) {
	$.cookie('metrics_' + this.name, null);
	console.log(this.padR('Metrics reset', 20) + this.padR('', 10) + this.commatize('', 10));

}

Metrics.clearAverage = function (name) {
	$.cookie('metrics_' + name, null);
	console.log('Metrics cleared for: ' + name);
	return true;
}